import { API, ShareAPI } from '../../../API';

const open = {
  '(': ')',
  '[': ']',
  '{': '}',
};
const close = new Set([')', ']', '}']);

/**
 * @param {string} s
 * @return {boolean}
 */
export const isValidQuery = (s, isAdvanced) => {
  const stack = [];

  for (let i = 0; i < s.length; i += 1) {
    const c = s[i];

    if (c === '\\') {
      return false;
    }

    if(isAdvanced) {
      if(c === '[' || c === ']') {
        continue
      } 
    }

    if (!open[c] && !close.has(c)) {
      continue;
    }

    if (open[c]) {
      stack.push(c);
      continue;
    }

    const pop = stack.pop();

    if (close.has(c) && open[pop] !== c) {
      return false;
    }
  }

  return stack.length === 0;
};

export const getSearchSuggestions = (s) => {
  let isValid = true;
  const stack = [];

  for (let i = 0; i < s.length; i += 1) {
    const c = s[i];

    if (!open[c] && !close.has(c)) {
      continue;
    }

    if (open[c]) {
      stack.push(c);
      continue;
    }

    const pop = stack.pop();

    if (close.has(c) && open[pop] !== c) {
      isValid = false;
      break;
    }
  }

  isValid = isValid && stack.length === 0;

  return {
    isValid,
    closing: stack.length === 1 ? open[stack[0]] : null,
  };
};



let newKeywordsValidatorTimeout;
export const newKeywordsValidator = function (keywordsQuery, setError, t, isShare = false, onMixedNearPairChange = () => {}) {
  if (newKeywordsValidatorTimeout !== null) {
    clearTimeout(newKeywordsValidatorTimeout);
  }

  if (!keywordsQuery) {
      setError(null);
      onMixedNearPairChange(false);
      return true;
  }

  return new Promise((resolve) => {
    newKeywordsValidatorTimeout = setTimeout(() => {
      validateKeywords(keywordsQuery, setError, resolve, t, isShare, onMixedNearPairChange);
    }, 700);
  });
}

let validateKeywordsAbortController = null;

const validateKeywords = (
  keywordsQuery,
  setError,
  callback,
  translator,
  isShare = false,
  onMixedNearPairChange = () => {}
) => {
  if (validateKeywordsAbortController) {
    validateKeywordsAbortController.abort();
  }
  validateKeywordsAbortController = new AbortController();

  let api = isShare ? ShareAPI : API;

  api.fetch(
    'POST',
    '/API/v1/validate_keywords',
    null,
    { keywords_query: keywordsQuery },
    validateKeywordsAbortController.signal
  ).then((data) => {
    const is_valid = data.is_valid;
    onMixedNearPairChange(Boolean(is_valid && data.has_mixed_near_pair));

    if (is_valid) {
      setError(null);
      callback(data.is_valid);
    } else {
      const error_message_raw = data.error_message_raw
        .replaceAll("{", "{{")
        .replaceAll("}", "}}");
      const error_parameters = data.error_parameters;
      const error_message_translated = translator(error_message_raw, error_parameters)
        .replaceAll("&amp;", "&")
        .replaceAll("&lt;", "<")
        .replaceAll("&gt;", ">")
        .replaceAll("&quot;", '"')
        .replaceAll("&apos;", "'")
        .replaceAll("&#x2F;", '/')
        .replaceAll("&#39;", "'");

      setError(error_message_translated);
      callback(data.is_valid);
    }
  }).catch((err) => {
    if (err.name === 'AbortError') {
      return;
    }
    setError('An error occurred');
    onMixedNearPairChange(false);
    callback(false);
  });
};
